<template>
  <section
    :class="{
      pagec: true,
      'animated-section': true,
      'section-active': ready
    }"
    style="overflow: hidden"
  >
    <div class="page-title">
      <h2>About <span>Me</span></h2>
    </div>

    <div class="section-content">
      <!-- Personal Information -->
      <div class="row">
        <div class="col-xs-12 col-sm-12" style="margin-bottom: 40px">
          <p>
            {{ data.about.me }}
          </p>
        </div>

        <div class="col-xs-12 col-sm-12">
          <div class="row">
            <div class="col-xs-12 col-sm-12">
              <div class="block-title">
                <h3>Personal <span>Info</span></h3>
              </div>
            </div>
          </div>

          <div class="info-list">
            <ul>
              <li v-for="(item, i) in data.about.personalInfo" :key="i">
                <span class="title">{{ item.name }}</span>
                <span class="value">{{ item.value }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- End of Personal Information -->

      <div class="white-space-50"></div>

      <!-- Services -->
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="block-title">
            <h3>What <span>I Do</span></h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-6" v-for="(item, i) in data.about.does" :key="i">
          <div class="info-block-w-icon">
            <div class="ci-icon">
              <i :class="item.icon"></i>
            </div>
            <div class="ci-text">
              <h4>{{ item.title }}</h4>
              <p>
                {{ item.describtion }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Services -->

      <div class="white-space-30"></div>

      <!-- Testimonials -->
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="block-title">
            <h3>Testimonials</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="testimonials owl-carousel">
            <!-- Testimonial -->
            <div v-for="(item, i) in data.about.testimonials" :key="i" class="testimonial">
              <div class="img">
                <img :src="item.avatar" :alt="item.name" />
              </div>
              <div class="text">
                <p>
                  {{ item.comment }}
                </p>
              </div>

              <div class="author-info">
                <h4 class="author">{{ item.name }}</h4>
                <h5 class="company">{{ item.city }}</h5>
                <div class="icon">
                  <i class="fas fa-quote-right"></i>
                </div>
              </div>
            </div>
            <!-- End of Testimonial -->
          </div>
        </div>
      </div>
      <!-- End of Testimonials -->

      <div class="white-space-50"></div>

      <!-- Clients -->
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="block-title">
            <h3>Cilents</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="clients owl-carousel">
            <div
              v-for="(item, i) in clientLogos"
              :key="i"
              :style="{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: item.width + 'px',
                height: '120px'
              }"
            >
              <a href="#" target="_blank" title="Logo">
                <img :src="item.src" :alt="item.alt" :style="{ width: item.width + 'px' }" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Clients -->

      <div class="white-space-50"></div>

      <!-- Pricing -->
      <!--      <div class="row">-->
      <!--        <div class="col-xs-12 col-sm-12">-->
      <!--          <div class="block-title">-->
      <!--            <h3>Pricing</h3>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="row">-->
      <!--        <div class="col-xs-12 col-sm-12">-->
      <!--          <div class="fw-pricing clearfix row">-->
      <!--            <div class="fw-package-wrap col-md-6">-->
      <!--              <div class="fw-package">-->
      <!--                <div class="fw-heading-row">-->
      <!--                  <span>Silver</span>-->
      <!--                </div>-->

      <!--                <div class="fw-pricing-row">-->
      <!--                  <span>$64</span>-->
      <!--                  <small>per month</small>-->
      <!--                </div>-->

      <!--                <div class="fw-button-row">-->
      <!--                  <a href="#" target="_self" class="btn btn-secondary">Free Trial</a>-->
      <!--                </div>-->

      <!--                <div class="fw-default-row">Lorem ipsum dolor</div>-->
      <!--                <div class="fw-default-row">Pellentesque scelerisque</div>-->
      <!--                <div class="fw-default-row">Morbi eu sagittis</div>-->
      <!--              </div>-->
      <!--            </div>-->

      <!--            <div class="fw-package-wrap col-md-6 highlight-col">-->
      <!--              <div class="fw-package">-->
      <!--                <div class="fw-heading-row">-->
      <!--                  <span>Gold</span>-->
      <!--                </div>-->

      <!--                <div class="fw-pricing-row">-->
      <!--                  <span>$128</span>-->
      <!--                  <small>per month</small>-->
      <!--                </div>-->

      <!--                <div class="fw-button-row">-->
      <!--                  <a href="#" target="_self" class="btn btn-primary">Free Trial</a>-->
      <!--                </div>-->

      <!--                <div class="fw-default-row">Lorem ipsum dolor</div>-->
      <!--                <div class="fw-default-row">Pellentesque scelerisque</div>-->
      <!--                <div class="fw-default-row">Morbi eu sagittis</div>-->
      <!--                <div class="fw-default-row">Donec non diam</div>-->
      <!--                <div class="fw-default-row"></div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!-- End of Pricing -->

      <div class="white-space-50"></div>

      <!-- Fun Facts -->
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="block-title">
            <h3>Fun <span>Facts</span></h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-4">
          <div class="fun-fact gray-default">
            <i class="lnr lnr-heart"></i>
            <h4>Happy Clients</h4>
            <span class="fun-fact-block-value">578</span>
            <span class="fun-fact-block-text"></span>
          </div>
        </div>

        <div class="col-xs-12 col-sm-4">
          <div class="fun-fact gray-default">
            <i class="lnr lnr-clock"></i>
            <h4>Working Hours</h4>
            <span class="fun-fact-block-value">4,780</span>
            <span class="fun-fact-block-text"></span>
          </div>
        </div>

        <div class="col-xs-12 col-sm-4">
          <div class="fun-fact gray-default">
            <i class="lnr lnr-star"></i>
            <h4>Awards Won</h4>
            <span class="fun-fact-block-value">15</span>
            <span class="fun-fact-block-text"></span>
          </div>
        </div>
      </div>
      <!-- End of Fun Facts -->
    </div>
  </section>
</template>
<script>
import { onMounted, ref, onBeforeUnmount, inject } from 'vue'

export default {
  setup() {
    const data = inject('data')
    const scrollbar = inject('scrollbar')
    const ready = ref(false)
    const clientLogos = ref(data.about.clientLogos)

    onMounted(() => {
      ready.value = true
      setTimeout(() => {
        scrollbar.enabled = true
        scrollbar.init = true
      }, 500)

      $('.testimonials.owl-carousel').imagesLoaded(function () {
        $('.testimonials.owl-carousel').owlCarousel({
          nav: true,
          items: 3,
          loop: true,
          navText: false,
          autoHeight: true,
          autoplay: true,
          autoplaySpeed: 2000,
          autoplayTimeout: 3000,
          margin: 25,
          responsive: { 0: { items: 1 }, 480: { items: 1 }, 768: { items: 2 }, 1200: { items: 2 } }
        })
      })

      $('.clients.owl-carousel')
        .imagesLoaded()
        .owlCarousel({
          nav: true,
          items: 2,
          loop: true,
          navText: false,
          autoplay: true,
          autoplaySpeed: 2000,
          autoplayTimeout: 3000,
          margin: 25,
          autoWidth: true,
          responsive: { 0: { items: 2 }, 768: { items: 4 }, 1200: { items: 4 } }
        })
    })

    onBeforeUnmount(() => {
      ready.value = false
      scrollbar.enabled = false
    })

    return { clientLogos, data, ready }
  }
}
</script>
